<template>
    <tr class="staff-add">
        <td colspan="8">
            <div class="staff-table-form">
                <div class="staff-form-wrapper">
                    <div class="wrapper">
                        <span
                            v-if="$v.staffMember.first_name.$invalid"
                            class="tooltiptext to-top"
                            v-text="errorDisplay($v.staffMember.first_name, { val: MAX_NAME_LENGTH })"
                        ></span>
                        <div
                            :class="[
                                'input-with-insidelabel',
                                {
                                    disabled: isFieldDisabled,
                                    tooltiperror: $v.staffMember.first_name.$invalid,
                                },
                            ]"
                        >
                            <input
                                id="listenInName"
                                ref="staffName"
                                type="text"
                                :value="staffMember.first_name"
                                :disabled="isFieldDisabled"
                                @input="
                                    update('first_name', $event.target.value) &&
                                        $v.staffMember.first_name.$touch()
                                "
                            />
                            <label for="listenInName">{{ $t('staff.membersTab.placeholder.name') }}</label>
                        </div>
                    </div>
                    <div class="wrapper">
                        <span
                            v-if="$v.staffMember.login_name.$invalid"
                            class="tooltiptext"
                            v-text="errorDisplay($v.staffMember.login_name, { val: MAX_NAME_LENGTH })"
                        ></span>
                        <div
                            :class="[
                                'input-with-insidelabel',
                                {
                                    tooltiperror: $v.staffMember.login_name.$invalid,
                                    disabled: isLoginFieldDisabled,
                                },
                            ]"
                        >
                            <input
                                id="listenInLoginName"
                                type="text"
                                :value="staffMember.isAAPrimary ? staffMember.login_name : ''"
                                :disabled="isLoginFieldDisabled"
                                @input="
                                    update('login_name', $event.target.value) &&
                                        $v.staffMember.login_name.$touch()
                                "
                            />
                            <label
                                for="listenInLoginName"
                                v-text="$t('staff.membersTab.placeholder.login')"
                            ></label>
                        </div>
                    </div>
                    <div class="wrapper">
                        <span
                            v-if="$v.staffMember.password.$invalid"
                            class="tooltiptext"
                            v-text="errorDisplay($v.staffMember.password, { val: MAX_PASSWORD_LENGTH })"
                        ></span>
                        <div
                            :class="[
                                'input-with-insidelabel',
                                {
                                    tooltiperror: $v.staffMember.password.$invalid,
                                    disabled: isPasswordFieldDisabled,
                                },
                            ]"
                        >
                            <input
                                id="listenInPassword"
                                type="password"
                                :value="staffMember.password"
                                :disabled="isPasswordFieldDisabled"
                                @input="
                                    update('password', $event.target.value) &&
                                        $v.staffMember.password.$touch()
                                "
                            />
                            <label
                                for="listenInPassword"
                                v-text="$t('staff.membersTab.placeholder.password')"
                            ></label>
                        </div>
                    </div>
                    <div class="wrapper">
                        <span
                            v-if="$v.staffMember.verifyPassword.$invalid"
                            class="tooltiptext"
                            v-text="errorDisplay($v.staffMember.verifyPassword, { val: MAX_PASSWORD_LENGTH })"
                        ></span>
                        <div
                            :class="[
                                'input-with-insidelabel',
                                {
                                    tooltiperror: $v.staffMember.verifyPassword.$invalid,
                                    disabled: isPasswordFieldDisabled,
                                },
                            ]"
                        >
                            <input
                                id="listenInVerifyPassword"
                                type="password"
                                :value="staffMember.verifyPassword"
                                :disabled="isPasswordFieldDisabled"
                                @input="
                                    update('verifyPassword', $event.target.value) &&
                                        $v.staffMember.verifyPassword.$touch()
                                "
                            />
                            <label
                                for="listenInVerifyPassword"
                                v-text="$t('staff.membersTab.placeholder.verifyPassword')"
                            ></label>
                        </div>
                    </div>
                </div>
                <div class="staff-form-wrapper">
                    <div class="wrapper">
                        <span v-if="$v.staffMember.message_group_id.$invalid" class="tooltiptext to-top">
                            <p
                                v-for="(error, index) in customErrorsForStaffMembers(
                                    $v.staffMember.message_group_id
                                )"
                                :key="index"
                                v-text="error"
                            ></p>
                        </span>
                        <SelectBox
                            v-model="staffMember.message_group_id"
                            :placeholder="$t('staff.membersTab.placeholder.number')"
                            :options="messageGroups"
                            :is-disabled="isFieldDisabled"
                            :invalid="$v.staffMember.message_group_id.$invalid"
                            :header-height="TABLE_HEADER_HEIGHT"
                        />
                        <input
                            type="hidden"
                            name="messageGroupId"
                            :value="staffMember.message_group_id"
                            @input="
                                update('message_group_id', $event.target.value) &&
                                    $v.staffMember.message_group_id.$touch()
                            "
                        />
                    </div>
                    <div class="wrapper card-number">
                        <div
                            :class="[
                                'input-with-insidelabel',
                                {
                                    tooltiperror: $v.staffMember.card_id.$invalid,
                                    tooltipwarning:
                                        $v.staffMember.isCardIdInUse.$invalid &&
                                        !$v.staffMember.card_id.$invalid,
                                    disabled: isFieldDisabled,
                                },
                            ]"
                        >
                            <span
                                v-if="$v.staffMember.card_id.$invalid"
                                class="tooltiptext to-top"
                                v-text="
                                    errorDisplay($v.staffMember.card_id, {
                                        vals: CARD_ID_LENGTHS_BUT_LAST_ONE,
                                        val: CARD_ID_LAST_ALLOWED_LENGTH,
                                    })
                                "
                            ></span>
                            <span
                                v-if="
                                    $v.staffMember.isCardIdInUse.$invalid && !$v.staffMember.card_id.$invalid
                                "
                                class="tooltiptext to-top warning"
                                ><i class="icon-allert"></i>
                                <span>{{ $t('validators.isCardIdInUse') }}</span>
                            </span>
                            <input
                                id="listenInCardName"
                                type="text"
                                :autocomplete="cardNameAutocomplete"
                                :value="staffMember.card_id"
                                :disabled="isFieldDisabled"
                                @input="
                                    update('card_id', $event.target.value) && $v.staffMember.card_id.$touch()
                                "
                            />
                            <label
                                for="listenInCardName"
                                v-text="$t('staff.membersTab.placeholder.cardNumber')"
                            ></label>
                        </div>
                        <button
                            :title="$t('staff.membersTab.cardIdTitle')"
                            :disabled="cancelTokenAutoCardId || isFieldDisabled"
                            @click="searchCardId"
                        >
                            <i class="icon-card-1" :title="$t('staff.membersTab.cardIdTitle')"></i>
                            <span class="icon-label">{{ $t('staff.membersTab.scanCardId') }}</span>
                        </button>
                        <Modal :show="scanCardIdModal" style-class="modal-staff" @close="cancelAutoRequest">
                            <div class="scan_card">
                                <img src="static/img/scan_card.svg" width="120" height="120" />
                                <div class="scan-header">
                                    {{ $t('staff.membersTab.modal.scanCardNumber') }}
                                </div>
                                <div class="scan-message">
                                    {{ $t('staff.membersTab.modal.pleaseHold') }}
                                </div>
                            </div>
                            <div slot="footer">
                                <button v-focus-inserted class="btn btn-cancel" @click="cancelAutoRequest">
                                    {{ $t('common.close') }}
                                </button>
                            </div>
                        </Modal>
                    </div>
                    <div class="wrapper staff-level">
                        <SelectBox
                            v-model="staffMember.card_action"
                            :placeholder="$t('staff.membersTab.placeholder.presenceAs')"
                            :options="orderedCardLevelOptionsByName"
                            :is-disabled="
                                !staffMember.card_id || isFieldDisabled || $v.staffMember.card_id.$invalid
                            "
                        />
                        <input
                            type="hidden"
                            name="cardAction"
                            :value="staffMember.card_action"
                            @input="update('card_action', $event.target.value)"
                        />
                    </div>
                    <div class="multiselect-wrapper">
                        <Multiselect
                            :placeholder="$t('staff.membersTab.placeholder.accessTo')"
                            :multiple="true"
                            :close-on-select="false"
                            :options="filteredAccessModuleOptions"
                            :select-label="emptyLabel"
                            :deselect-label="emptyLabel"
                            :selected-label="emptyLabel"
                            :value="staffMember.accessModules"
                            label="name"
                            track-by="name"
                            :disabled="!staffMember.card_id || $v.staffMember.card_id.$invalid"
                            @input="updateAccessModules"
                            @search-change="updateAccessModulesQuery"
                        >
                            <span slot="noResult" v-text="$t('common.noSearchResults')"></span>
                        </Multiselect>
                    </div>
                </div>
                <div class="staff-form-wrapper">
                    <div class="wrapper chkbox">
                        <input
                            id="assignable"
                            type="checkbox"
                            :checked="staffMember.assignable"
                            :disabled="checkBoxDisabled"
                            @change="update('assignable', $event.target.checked)"
                        />
                        <label for="assignable"></label>
                        <label
                            for="assignable"
                            v-text="$t('staff.membersTab.placeholder.usedInAssignments')"
                        ></label>
                    </div>
                    <div class="wrapper">
                        <span
                            v-if="$v.staffMember.comment.$invalid"
                            class="tooltiptext to-top"
                            v-text="errorDisplay($v.staffMember.comment, { val: MAX_COMMENT_LENGTH })"
                        ></span>
                        <div
                            :class="[
                                'textarea-with-insidelabel has-5-rows',
                                {
                                    tooltiperror: $v.staffMember.comment.$invalid,
                                    disabled: !staffMember.isAAPrimary,
                                },
                            ]"
                        >
                            <textarea
                                id="listenInComment"
                                :value="staffMember.comment"
                                :disabled="!staffMember.isAAPrimary"
                                @input="
                                    update('comment', $event.target.value) && $v.staffMember.comment.$touch()
                                "
                            ></textarea>
                            <label
                                for="listenInComment"
                                v-text="$t('staff.membersTab.placeholder.comment')"
                            ></label>
                        </div>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script type="text/babel">
import Multiselect from 'moxa-vue-multiselect';
import Modal from '../common/Modal.vue';
import orderBy from 'lodash-es/orderBy';
import SelectBox from '../common/SelectBox.vue';
import { getCardLevelOptions } from '../staff/staffUtils';
import mappingState from '../common/mappingState';
import {
    customErrorsForStaffMembers,
    errorDisplay,
    forbidden,
    forbiddenNames,
    forbiddenPassword,
    forbiddenReservedLogins,
    forbiddenStaffLogin,
    forbiddenStaffName,
    isCardIdInUse,
    isCardIdInUseBySuperUser,
    isCardIdInUseByStaffFromAnotherAA,
    maximumCardIdLength,
    maximumCommentLength,
    maximumNameLength,
    maximumPasswordLength,
    minimumLength,
    minimumLoginLength,
    noPhoneNumberStaff,
    noPhoneNumberStaffGroup,
    passwordRequired,
    passwordsMatch,
    verifyChecksum,
} from '../../validators';
import {
    CARD_ID_LENGTHS_BUT_LAST_ONE,
    CARD_ID_LAST_ALLOWED_LENGTH,
    MAX_COMMENT_LENGTH,
    MAX_NAME_LENGTH,
    MAX_PASSWORD_LENGTH,
    TABLE_HEADER_HEIGHT,
    USER_TYPES,
    SUCCESS,
} from '../../constants';
import { getCancelToken } from '../../api';
import { resourceCardId } from '../../api/resources';
import commonDirectives from '../common/commonDirectives';

export default {
    name: 'AddEditStaffForm',

    components: {
        Modal,
        Multiselect,
        SelectBox,
    },

    /**
     * mixins won't be duplicated in copyboard
     * because AddEditStaffForm can only be instance in whole system
     */
    mixins: [mappingState, commonDirectives],

    constants: {
        CARD_ID_LENGTHS_BUT_LAST_ONE,
        CARD_ID_LAST_ALLOWED_LENGTH,
        MAX_COMMENT_LENGTH,
        MAX_NAME_LENGTH,
        MAX_PASSWORD_LENGTH,
        TABLE_HEADER_HEIGHT,
        USER_TYPES,
    },

    props: {
        staffMember: {
            type: Object,
            required: true,
        },
        accessModuleOptions: {
            type: Array,
            required: true,
        },
        allStaffMembers: {
            type: Array,
            required: true,
        },
        allStaffGroups: {
            type: Array,
            required: true,
        },
        messageGroupOptions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            accessModulesQuery: '',
            emptyLabel: '',
            oldLogin: this.staffMember.login_name,
            messageGroups: [],
            otherStaff: [],
            cardIdUsed: false,
            cancelTokenAutoCardId: null,
            cardLevelOptions: getCardLevelOptions.call(this),
            scanCardIdModal: false,
            timeoutResolve: null,
            cardNameAutocomplete: 'on',
        };
    },

    validations() {
        return {
            staffMember: {
                first_name: {
                    minimumLength,
                    forbiddenStaffName,
                    maximumNameLength,
                    forbiddenNames: (val, rule) => {
                        rule = this.existedNames;
                        return forbiddenNames(val, rule);
                    },
                },
                message_group_id: {
                    noPhoneNumberStaff: val =>
                        noPhoneNumberStaff({
                            val,
                            isAssigned: this.staffMember.assigned,
                        }),
                    noPhoneNumberStaffGroup: val =>
                        noPhoneNumberStaffGroup({
                            val,
                            assignedGroupNames: this.staffMember.assignedGroupNames,
                        }),
                },
                login_name: {
                    minimumLoginLength: (val, type) => {
                        type = this.userType;
                        return minimumLoginLength(val, type);
                    },
                    forbiddenStaffLogin,
                    maximumNameLength,
                    forbiddenReservedLogins,
                    forbiddenNames: (val, rule) => {
                        rule = this.existedLogins;
                        return forbiddenNames(val, rule);
                    },
                },
                password: {
                    forbiddenPassword: val =>
                        forbiddenPassword({
                            val,
                            value: this.staffMember,
                        }),
                    maximumPasswordLength: val =>
                        maximumPasswordLength({
                            val,
                            value: this.staffMember,
                        }),
                    passwordRequired: val =>
                        passwordRequired({
                            val,
                            value: this.staffMember,
                            needToChangePwd: this.staffMember.loginIsChanged,
                        }),
                },
                verifyPassword: {
                    forbiddenPassword: val =>
                        forbiddenPassword({
                            val,
                            value: this.staffMember,
                        }),
                    maximumPasswordLength: val =>
                        maximumPasswordLength({
                            val,
                            value: this.staffMember,
                        }),
                    passwordRequired: val =>
                        passwordRequired({
                            val,
                            value: this.staffMember,
                            needToChangePwd: this.staffMember.loginIsChanged,
                        }),
                    passwordsMatch: val =>
                        passwordsMatch({
                            val,
                            value: this.staffMember,
                        }),
                },
                card_id: {
                    forbidden,
                    maximumCardIdLength,
                    verifyChecksum,
                    isCardIdInUseBySuperUser: () => {
                        if (!this.isSystemAdmin) {
                            return isCardIdInUseBySuperUser({
                                cardIdUsed: this.cardIdUsed,
                                staff: this.staffWithCard,
                            });
                        }
                        return true;
                    },
                },
                isCardIdInUse: {
                    isCardIdInUse: () =>
                        isCardIdInUse({
                            cardIdUsed: this.cardIdUsed,
                            staff: this.staffWithCard,
                        }),
                },
                cardIdUsedByStaffFromAnotherAA: {
                    isCardIdInUseByStaffFromAnotherAA: () => {
                        if (!this.$v.staffMember.card_id.$invalid) {
                            return isCardIdInUseByStaffFromAnotherAA({ staff: this.staffWithCard });
                        }

                        return false;
                    },
                },

                comment: { forbidden, maximumCommentLength },
            },
            validGroup: [
                'staffMember.first_name',
                'staffMember.message_group_id',
                'staffMember.login_name',
                'staffMember.password',
                'staffMember.card_id',
                'staffMember.verifyPassword',
                'staffMember.comment',
            ],
        };
    },

    computed: {
        orderedCardLevelOptionsByName() {
            return this.cardLevelOptions
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
        },

        filteredAccessModuleOptions() {
            let options = this.accessModuleOptions.filter(module => {
                return module.name.indexOf(this.accessModulesQuery) !== -1;
            });

            return orderBy(options, 'name');
        },

        existedNames() {
            return this.otherStaff
                .map(item => ({ name: item.first_name }))
                .concat(this.allStaffGroups.map(group => ({ name: group.name })));
        },

        existedLogins() {
            return this.otherStaff.map(item => ({ name: item.login_name }));
        },

        checkBoxDisabled() {
            if (this.isFieldDisabled) {
                return true;
            }

            if (!this.staffMember.assignable) {
                return false;
            }

            return this.staffMember.assigned || this.staffMember.userIsLastAssignableInAssignedGroup;
        },

        isSystemAdmin() {
            return this.userType === USER_TYPES.SYS_ADMIN;
        },

        isUserAdmin() {
            return this.userType === USER_TYPES.USER_ADMIN;
        },

        isFieldDisabled() {
            return (
                !this.staffMember.isAAPrimary ||
                (this.isUserAdmin && this.staffMember.type === USER_TYPES.SUPER_USER)
            );
        },

        isLoginFieldDisabled() {
            if (!this.isFieldDisabled) {
                if (this.isSystemAdmin) {
                    return false;
                }

                let isSelf = this.staffMember.user_id === this.userId;
                let isStaff = this.staffMember.type === USER_TYPES.USER;

                return isSelf || !isStaff;
            }

            return true;
        },

        isPasswordFieldDisabled() {
            if (!this.isFieldDisabled) {
                let hasLogin = this.staffMember.login_name.trim() !== '';

                return !hasLogin;
            }

            return true;
        },

        staffWithCard() {
            if (this.cardIdUsed) {
                return this.getStaffByCardId(this.staffMember.card_id);
            }

            return null;
        },
    },

    watch: {
        staffMember: {
            handler() {
                this.setUnsavedChanges(true);
            },
            deep: true,
        },

        '$v.validGroup.$invalid'(value) {
            this.setFormValid(!value);
        },

        'staffMember.login_name'(loginName) {
            this.staffMember.loginIsChanged = loginName.trim() !== this.oldLogin.trim();
        },

        'staffMember.card_id'(cardId, oldValue) {
            if (cardId !== oldValue) {
                this.cardIdUsed = !this.$v.staffMember.card_id.$invalid && this.isCardIdInUse(cardId);
                if (this.cardIdUsed) {
                    if (!this.isSystemAdmin) {
                        // On staff members page not possible to edit super users
                        if (
                            this.cardIdUsed &&
                            this.staffWithCard &&
                            this.staffWithCard.type !== USER_TYPES.SUPER_USER
                        ) {
                            this.cardNameAutocomplete = 'off';
                            this.confirmation({
                                confirmTitle: this.$t('staff.membersTab.cardIsUsedTitle'),
                                confirmBody: this.$t('staff.membersTab.cardIsUsed', {
                                    val: this.staffWithCard.first_name,
                                }),
                            }).then(r => {
                                this.cardNameAutocomplete = 'on';
                                if (r) {
                                    this.$emit('edit-another-staff', this.staffWithCard);
                                }
                            });
                        }
                    } else {
                        // For super users page possible only to edit anothre SU
                        if (
                            this.cardIdUsed &&
                            this.staffWithCard &&
                            this.staffWithCard.type === USER_TYPES.SUPER_USER
                        ) {
                            this.cardNameAutocomplete = 'off';
                            this.confirmation({
                                confirmTitle: this.$t('staff.membersTab.cardIsUsedTitle'),
                                confirmBody: this.$t('staff.membersTab.cardIsUsed', {
                                    val: this.staffWithCard.first_name,
                                }),
                            }).then(r => {
                                this.cardNameAutocomplete = 'on';
                                if (r) {
                                    this.$emit('edit-another-staff', this.staffWithCard);
                                }
                            });
                        }
                    }
                }
            }
        },
    },

    beforeDestroy() {
        this.cancelAutoRequest();
    },

    created() {
        this.updateData();
        // Preload images
        const img = new Image();
        img.src = 'static/img/scan_card.svg';
        img.src = 'static/img/scan complete.svg';
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.staffName.select();
        });

        this.setFormValid(!this.$v.validGroup.$invalid);

        this.$emit('scroll-to-edited-staff');
    },

    methods: {
        errorDisplay,

        updateData() {
            this.messageGroups = this.getMessageGroups();
            this.otherStaff = this.getOtherStaff();
        },

        customErrorsForStaffMembers(obj) {
            return customErrorsForStaffMembers(obj, {
                assignedGroupNames: this.staffMember.assignedGroupNames,
            });
        },

        isCardIdInUse(cardId) {
            if (!cardId) {
                return false;
            }

            return this.otherStaff.some(staff => {
                let staffCardId = staff.card_id && staff.card_id.toLowerCase().trim();
                return staffCardId === cardId.toLowerCase().trim();
            });
        },

        getOtherStaff() {
            let currentUserId = this.staffMember.user_id || null;
            if (currentUserId) {
                return this.allStaffMembers.filter(item => item.user_id !== currentUserId);
            }

            return [].concat(this.allStaffMembers);
        },

        updateAccessModules(items) {
            this.update('accessModules', items);
        },

        getStaffByCardId(cardId) {
            if (!cardId) {
                return null;
            }

            return this.otherStaff.find(staff => {
                let staffCardId = staff.card_id && staff.card_id.toLowerCase().trim();
                return staffCardId === cardId.toLowerCase().trim();
            });
        },

        getUsedMessageGroupIds() {
            return this.allStaffMembers.reduce((usedMessageGroupsIds, staff) => {
                if (this.staffMember.user_id === staff.user_id) {
                    return usedMessageGroupsIds;
                }

                let useCallId = this.staffMember.type === USER_TYPES.SUPER_USER;
                let id = useCallId ? staff.call_id : staff.message_group_id;

                if (!id) {
                    return usedMessageGroupsIds;
                }

                // save only unique ids
                let set = new Set(usedMessageGroupsIds.concat(id));
                return Array.from(set);
            }, []);
        },

        getMessageGroups() {
            let ids = this.getUsedMessageGroupIds();

            return this.messageGroupOptions.map(item => {
                let newItem = { ...item };

                if (ids.includes(newItem.value)) {
                    newItem.commentId = 'common.inUse';
                }

                return newItem;
            });
        },

        updateAccessModulesQuery(query) {
            this.accessModulesQuery = query;
        },

        update(field, item) {
            this.staffMember[field] = item;
        },

        searchCardId() {
            this.scanCardIdModal = true;
            return this.getCardId()
                .then(card_id => {
                    this.staffMember.card_id = card_id;
                    this.popup({
                        type: SUCCESS,
                        header: this.$t('common.success'),
                        text: this.$t('staff.membersTab.modal.readSuccess'),
                    });
                    this.scanCardIdModal = false;
                })
                .catch(() => {
                    this.scanCardIdModal = false;
                });
        },

        getCardId() {
            this.cancelTokenAutoCardId = getCancelToken();

            return resourceCardId({
                cancelToken: this.cancelTokenAutoCardId.token,
            })
                .then(response => {
                    this.cancelTokenAutoCardId = null;
                    if (response.data) {
                        if (response.data === 'null') {
                            return this.getCardId();
                        } else if (response.data.card_id) {
                            return response.data.card_id;
                        }
                    }

                    return Promise.reject();
                })
                .catch(() => {
                    this.cancelTokenAutoCardId = null;
                    return Promise.reject();
                });
        },

        cancelAutoRequest() {
            this.scanCardIdModal = false;
            if (this.timeoutResolve) {
                this.timeoutResolve();
            }
            if (this.cancelTokenAutoCardId) {
                this.cancelTokenAutoCardId.cancel();
            }
        },
    },
};
</script>
